import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { ASSETS } from "../../components/Decorative";
import { Lock, Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";

const AdminLogin = () => {
    const { user, login, loading } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    if (loading) return null;
    if (user) return <Navigate to="/admin" replace />;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        try {
            await login(email, password);
            toast.success("Willkommen zurück!");
            navigate("/admin");
        } catch (err) {
            const detail = err?.response?.data?.detail;
            const msg = typeof detail === "string" ? detail : "Anmeldung fehlgeschlagen";
            setError(msg);
            toast.error(msg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen garden-bg flex items-center justify-center px-5 py-16" data-testid="admin-login-page">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <img src={ASSETS.mascot} alt="" className="w-24 mx-auto mb-3" aria-hidden="true" />
                    <h1 className="font-serif text-3xl text-deep-green">Admin-Bereich</h1>
                    <p className="font-cursive text-2xl text-pastel-pink-dark mt-1">~ willkommen zurück ~</p>
                </div>

                <form
                    onSubmit={handleSubmit}
                    className="bg-white rounded-3xl shadow-[0_20px_50px_rgba(44,76,59,0.1)] border border-cream-dark p-8 space-y-5"
                    data-testid="admin-login-form"
                >
                    <div>
                        <label className="block text-sm font-medium text-deep-green mb-1.5">E-Mail</label>
                        <div className="relative">
                            <Mail className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-deep-green/50" />
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full pl-10 pr-4 py-3 rounded-2xl border border-cream-dark bg-cream-dark/30 focus:bg-white focus:outline-none focus:ring-2 focus:ring-garden-green/30 transition"
                                placeholder="admin@softeisgarten.de"
                                data-testid="login-email-input"
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-deep-green mb-1.5">Passwort</label>
                        <div className="relative">
                            <Lock className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-deep-green/50" />
                            <input
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full pl-10 pr-4 py-3 rounded-2xl border border-cream-dark bg-cream-dark/30 focus:bg-white focus:outline-none focus:ring-2 focus:ring-garden-green/30 transition"
                                placeholder="••••••••"
                                data-testid="login-password-input"
                            />
                        </div>
                    </div>

                    {error && (
                        <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-4 py-2.5" data-testid="login-error">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={submitting}
                        className="w-full bg-garden-green hover:bg-garden-green-dark text-white rounded-full py-3 font-semibold shadow-md hover:shadow-lg disabled:opacity-50 transition flex items-center justify-center gap-2"
                        data-testid="login-submit-button"
                    >
                        {submitting && <Loader2 className="w-4 h-4 animate-spin" />}
                        Anmelden
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
